module.exports = __webpack_public_path__ + "static/img/iphone_1.da67e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_1.png
// module id = XlSM
// module chunks = 0